import React, { useEffect, useState } from 'react'
import { usePrintableWorksheetsState } from 'printableWorksheets/state'
import { WorksheetCard } from '../worksheetsView/worksheetCard/worksheetCard';
import { getAllWorksheets, getSearchResults } from 'printableWorksheets/api';
import EmptySearchIcon from './empty-search-icon.svg'
import CircleAnimation from 'apps/atoms/CircleAnimation';
import './styles.scss'

interface IAllWorksheetsScreen {
    nodeId: any;
    dontShowLoader?: boolean;
}

const AllWorksheetsScreen: React.FC<IAllWorksheetsScreen> = ({nodeId, dontShowLoader = false}) => {

    const [allWorksheetsOfNode, setAllWorksheetsOfNode] = useState<any>([]);
    const { activeGrade } = usePrintableWorksheetsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchSearchData = async () => {
        setIsLoading(true);
        const res = await getAllWorksheets({ nodeId });
        if (res?.search_contents?.[nodeId]?.length > 0) {
            setAllWorksheetsOfNode(res?.search_contents[nodeId]);
        }
        setIsLoading(false)
    }

    useEffect(() => {
        nodeId && fetchSearchData();
    }, [nodeId]);

    useEffect(() => {
        return () => {
            setAllWorksheetsOfNode([]);
        }
    }, [])

    return (
        <div className={`all-worksheets`}>
            {isLoading && !dontShowLoader ? (
                <div className="all-worksheets__loading-container">
                    <CircleAnimation />
                </div>
            ) : (
                <div className={`all-worksheets__list`}>
                    {allWorksheetsOfNode?.length > 0 ? allWorksheetsOfNode.map((worksheet: any, index: any) => {
                        return (
                            <div
                                key={worksheet.id}
                            >
                                <WorksheetCard
                                    card={worksheet}
                                />
                            </div>
                        )
                    }) : (
                       <>{!dontShowLoader ? (
                        <div className="empty-container">
                            <div className="empty-saved-worksheets-body">
                                <EmptySearchIcon />
                                <div className="main-text">{`No result found in Grade ${activeGrade}`}</div>
                                <p className="align-centre">{`Sorry! we couldn’t find what you are looking for,
                Please try again`}
                                </p>
                            </div>
                        </div>
                       ) : null}</>
                    )}
                </div>
            )}
        </div>
    );
}

export default AllWorksheetsScreen